import { useState } from "react"

import PropTypes from "prop-types"

// MUI
import { Grid, Pagination } from "@mui/material"

// --------------------------------------------|| TABLE PAGINATION - COMPONENTS || -------------------------------------

const TablePagination = ({ gotoPage, total, setPageSize, pageSize, pageIndex, selectPage }) => {
  // Use State
  // const [open, setOpen] = useState(false)
  //
  // const handleClose = () => {
  //   setOpen(false)
  // }
  //
  // const handleOpen = () => {
  //   setOpen(true)
  // }

  const handleChangePagination = (event, value) => {
    // gotoPage(value - 1)
    selectPage(value - 1)
  }

  // const handleChange = event => {
  //   setPageSize(+event.target.value)
  // }

  return (
    <Grid container alignItems='center' justifyContent='space-between' sx={{ width: "auto" }}>
      <Grid item>
        {/*<Stack direction="row" spacing={1} alignItems="center">*/}
        {/*  <Stack direction="row" spacing={1} alignItems="center">*/}
        {/*    <Typography variant="caption" fontSize={10}>*/}
        {/*      ردیف در صفحه*/}
        {/*    </Typography>*/}
        {/*    <FormControl sx={{ m: 1 }}>*/}
        {/*      <Select*/}
        {/*        id="demo-controlled-open-select"*/}
        {/*        open={open}*/}
        {/*        onClose={handleClose}*/}
        {/*        onOpen={handleOpen}*/}
        {/*        // @ts-ignore*/}
        {/*        value={pageSize}*/}
        {/*        onChange={handleChange}*/}
        {/*        size="small"*/}
        {/*        sx={{ '& .MuiSelect-select': { py: 0.75, px: 1.25 } }}*/}
        {/*      >*/}
        {/*        <MenuItem value={5}>5</MenuItem>*/}
        {/*        <MenuItem value={10}>10</MenuItem>*/}
        {/*        <MenuItem value={25}>25</MenuItem>*/}
        {/*        <MenuItem value={50}>50</MenuItem>*/}
        {/*        <MenuItem value={100}>100</MenuItem>*/}
        {/*      </Select>*/}
        {/*    </FormControl>*/}
        {/*  </Stack>*/}
        {/*  <Typography variant="caption" fontSize={10}>*/}
        {/*    برو به*/}
        {/*  </Typography>*/}
        {/*  <TextField*/}
        {/*    size="small"*/}
        {/*    type="number"*/}
        {/*    // @ts-ignore*/}
        {/*    value={pageIndex + 1}*/}
        {/*    onChange={e => {*/}
        {/*      const page = e.target.value ? Number(e.target.value) : 0*/}
        {/*      gotoPage(page - 1)*/}
        {/*    }}*/}
        {/*    sx={{ '& .MuiOutlinedInput-input': { py: 0.75, px: 1.25, width: 36 } }}*/}
        {/*  />*/}
        {/*</Stack>*/}
      </Grid>
      <Grid item sx={{ my: { xs: 2, sm: 2 } }}>
        <Pagination
          count={Math.ceil(total / pageSize)}
          page={pageIndex + 1}
          onChange={handleChangePagination}
          variant='combined'
          showFirstButton
          showLastButton
          size='medium'
        />
      </Grid>
    </Grid>
  )
}

TablePagination.propTypes = {
  gotoPage: PropTypes.func,
  setPageSize: PropTypes.func,
  pageIndex: PropTypes.number,
  pageSize: PropTypes.number,
  rows: PropTypes.array
}

export default TablePagination
